// extracted by mini-css-extract-plugin
export default {"checkboxParent":"CheckBox_checkboxParent__KPs7w","checkbox":"CheckBox_checkbox__ip6te","label":"CheckBox_label__ezgs8"};